import React, {
  MouseEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import InputLabel from '@material-ui/core/InputLabel';
import { Box, Button, Divider, Tab, Tabs, Typography, IconButton } from '@material-ui/core';

import { ValidationError } from 'yup';
import SearchField, { SearchFieldHandles } from '../../components/SearchField';
import Select from '../../components/Select';
import InputLogged from '../../components/InputLogged';
import { FaDollarSign } from 'react-icons/fa';

import {
  AdvancedSearch,
  Balance,
  ButtonsContainer,
  Container,
  InputWrapper,
  PageBody,
  PageTitle,
  TagsOperations,
} from './styles';
import stylesMaterial from './stylesMaterial';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import { OptionType } from '../Historico';

import OrderLabelsService from '../../services/OrderLabelsService';
import getValidationErrors from '../../utils/getValidationErrors';
import melhorEnvioService from '../../services/melhorEnvio';
import EnhancedTable, { TableData } from './Table';
import { AddBalanceModal } from './AddBalanceModal';
import { useParams } from 'react-router-dom';
import ListOrderLabelsServiceResponse from '../../interfaces/IListOrderLabels';
import moneyMask from '../../utils/moneyMask';
import { moneyFormat } from '../../utils/moneyFormat';

export function Tags() {
  const classes = stylesMaterial();

  const isFirstRender = useRef(true);
  const formRef = useRef<FormHandles>(null);
  const searchFieldRef = useRef<SearchFieldHandles>(null);
  const { orderId } = useParams<{ orderId: string }>();

  const { user } = useAuth();
  const { addToast } = useToast();

  const [selectedBranch, setSelectedBranch] = useState<OptionType>({
    id: user.empresa_id,
    value: user.empresa_id,
    label: user.empresa_nome_fantasia,
  });
  const [branchs, setBranchs] = useState<OptionType[]>([
    {
      id: user.empresa_id,
      value: user.empresa_id,
      label: user.empresa_nome_fantasia,
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [ordersForTable, setOrdersForTable] = useState<TableData[]>([]);
  const [ordersLocal, setOrdersLocal] = useState<ListOrderLabelsServiceResponse>([]);
  const [filteredOrdersForTable, setFilteredOrdersForTable] = useState<TableData[]>([]);
  const [selected, setSelected] = useState<string[]>([]);
  const [tabValue, setTabValue] = React.useState(0);
  const [balance, setBalance] = useState(0);
  const [openAddBalanceModal, setOpenAddBalanceModal] = useState(false);

  const possibleStatus: { [x: number]: string } = {
    0: '',
    1:'pending',
    2:'released',
    3:'posted',
    4:'delivered',
    5:'canceled',
    6:'undelivered'
  }

  useEffect(() => {
    handleGetBalance();
    handleGetOrders('');
  }, [orderId]);

  useEffect(() => {
    handleGetOrders(possibleStatus[tabValue]);
  }, [tabValue]);

  function handleGetBalance() {
    melhorEnvioService.showBalance(selectedBranch.id).then((res) => setBalance(res.balance)).catch((error) =>{
      console.log(error);
    });
  }

  function handleGetOrders(status: string) {
    melhorEnvioService.showTags(status, selectedBranch.id).then((res) => {
      const orders = res.data.map((order) => {

        return {
          orderLabelId: order.id,
          id: Number(order.tags[0].tag),
          customerName: order.to.name || '',
          price: order.price.toFixed(2),
          orderLabelStatus: order.status,
          tracking: order.tracking || ''
        };
      });
      setOrdersForTable(orders);
      setFilteredOrdersForTable(orders);
    }).catch((error) =>{
      console.log(error);
    });
  }
  
  const handleGetOrderLabels = useCallback(
    async (
      companyId: number,
      startedAt: string,
      endedAt: string,
      customerName: string,
      orderId: string,
      orderLabelId: string,
    ) => {
      setLoading(true);

      try {
        const orderLabelsList = await OrderLabelsService.listOrderLabels(
          companyId,
          startedAt,
          endedAt,
          customerName,
          orderId,
          orderLabelId,
        );

        setOrdersLocal(orderLabelsList);
      } catch (error) {
        if (error instanceof Error) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [addToast, ordersForTable],
  );

  useEffect(() => {
    if (isFirstRender.current && selectedBranch.value && ordersForTable.length > 0) {
      isFirstRender.current = false;
      
      if(orderId) {
        handleGetOrderLabels(selectedBranch.value, '', '', '', orderId, '');

        const labelsIds = ordersForTable.filter((order) => order.id === Number(orderId)).map((order) => order.orderLabelId);
        setSelected(labelsIds);
      } else {
        handleGetOrderLabels(selectedBranch.value, '', '', '', '', '');
      }
    }
  }, [selectedBranch, handleGetOrderLabels, ordersForTable]);

  useEffect(() => {
    if (ordersForTable.length && ordersLocal.length) {
      const ordersLabelId = ordersLocal
        .map((orderLabel) => orderLabel.tags.map((tag) => tag.tagId))
        .reduce((prev,next) => prev.concat(next));
      ;
      const filteredOrders = ordersForTable.filter((order) => {
        return ordersLabelId.includes(order.orderLabelId);
      });

      setFilteredOrdersForTable(filteredOrders);
    }
  }, [ordersForTable, ordersLocal]);

  function handleSubmit(data: any) {
    formRef.current?.setErrors({});

    try {
      let orderId = '';
      let orderLabelId = '';
      let customerName = '';

      const startedAt = data.from
        ? `${new Date(data.from).toISOString().split('T')[0]}T00:00:00`
        : '';
      const endedAt = data.to
        ? `${new Date(data.to).toISOString().split('T')[0]}T23:59:59`
        : '';

      const filter = searchFieldRef.current?.getFilter();

      switch (filter) {
        case 'cliente': {
          customerName = data.search;
          break;
        }
        case 'pedido': {
          if (isNaN(data.search)) {
            return addToast({
              title: 'O número do pedido precisa ser um número',
              type: 'error',
            });
          }

          orderId = data.search;
          break;
        }
        case 'numero': {
          orderLabelId = data.search;

          if (isNaN(data.search)) {
            return addToast({
              title: 'O número da etiqueta precisa ser um número',
              type: 'error',
            });
          }

          break;
        }
        default: {
          break;
        }
      }

      handleGetOrderLabels(
        selectedBranch.value,
        startedAt,
        endedAt,
        customerName,
        orderId,
        orderLabelId,
      );
    } catch (error) {
      let errors = {};

      if (error instanceof ValidationError) {
        errors = getValidationErrors(error);

        formRef.current?.setErrors(errors);
      }
    }
  }

  const clearForm = useCallback(() => {
    formRef.current?.reset();
    formRef.current?.setErrors({});
    setSelectedBranch({
      id: user.empresa_id,
      value: user.empresa_id,
      label: user.empresa_nome_fantasia,
    });
  }, [user]);

  function handleGenerate() {
    melhorEnvioService.generateTags(selected, selectedBranch.id).then((res) => {
      handleGetBalance();
      handleGetOrders(possibleStatus[tabValue]);
      addToast({
        title: `Etiqueta(s) geradas(s) com sucesso`,
        type: 'success',
      });
      formRef.current?.submitForm();
    }).catch((error) => {
      if(error.response && error.response.data){
        addToast({
          title: error.response.data.message,
          type: 'error',
        });
      } else {
        addToast({
          title: 'Ocorreu um erro na geração de etiqueta(s)',
          type: 'error',
        });
      }
    });
  }

  function handlePrint() {
    melhorEnvioService.pritnTags(selected, selectedBranch.id).then((res) => {
      addToast({
        title: `Impressão geradas com sucesso`,
        type: 'success',
      });

      window.open(res.url);
    }).catch((error) => {
      if(error.response && error.response.data){
        addToast({
          title: error.response.data.message,
          type: 'error',
        });
      } else {
        addToast({
          title: 'Ocorreu um erro na impressão de etiqueta(s)',
          type: 'error',
        });
      }
    });
  }

  function a11yProps(index: any) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box 
            p={3}
            className={classes.tabPanel}
          >
            {children}
          </Box>
        )}
      </div>
    );
  }

  const handleOpenAddBalance = () => {
    setOpenAddBalanceModal(true);
  };

  const handleCloseAddBalance = () => {
    setOpenAddBalanceModal(false);
  };

  return (
    <Container>
      <PageTitle>
        <h1>Etiquetas</h1>
        <h3>
          Realize a administração das etiquetas de envio por transportadoras
          aqui. Etiquetas 
        </h3>
      </PageTitle>

      <PageBody>
        <Form id="search-form" ref={formRef} onSubmit={handleSubmit}>
          <AdvancedSearch>
            <div className="group__tenant">
              <InputLabel htmlFor="tenant_id" className={classes.label}>
                Loja
              </InputLabel>
              <Select
                id="tenant_id"
                name="tenant_id"
                placeholder="Selecione a loja"
                value={selectedBranch}
                onChange={(value) => setSelectedBranch(value as OptionType)}
                options={branchs}
              />
            </div>
            <div className="group__tenant__search">
              <SearchField
                ref={searchFieldRef}
                name="search"
                placeholder="Pesquisa"
                containerStyle={{ height: '38px' }}
                filters={[
                  { id: 0, value: 'numero', label: 'Numero da etiqueta' },
                  { id: 1, value: 'pedido', label: 'Número do pedido' },
                  { id: 2, value: 'cliente', label: 'Cliente' },
                ]}
              />
            </div>
          </AdvancedSearch>

          <AdvancedSearch>
            <div className="group">
              <div className="group__input">
                <InputWrapper>
                  <InputLabel htmlFor="from" className={classes.label}>
                    De
                  </InputLabel>
                  <InputLogged
                    id="from"
                    name="from"
                    containerStyle={{ height: '38px' }}
                    type="date"
                  />
                </InputWrapper>
                <InputWrapper>
                  <InputLabel htmlFor="to" className={classes.label}>
                    Até
                  </InputLabel>
                  <InputLogged
                    id="to"
                    name="to"
                    type="date"
                    containerStyle={{ height: '38px' }}
                  />
                </InputWrapper>
              </div>
            </div>
          </AdvancedSearch>
        </Form>
        <ButtonsContainer>
          <Button
            type="button"
            className={classes.clearFiltersButton}
            onClick={clearForm}
            disabled={loading}
          >
            Limpar filtros
          </Button>
          <Button
            type="submit"
            form="search-form"
            className={classes.consultButton}
            disabled={loading}
          >
            Consultar
          </Button>
        </ButtonsContainer>

        <Divider className={classes.divider} />
        
        <Balance>
          <div>
            <FaDollarSign size={24} />
            <Typography className={classes.balance}>
              Saldo: <strong>{moneyFormat(balance)}</strong>
            </Typography>
          </div>
          
          <Button 
            aria-label='Adicionar saldo'
            title='Adicionar saldo' 
            component='span'
            onClick={handleOpenAddBalance}
            className={`${classes.addBalance} ${classes.button}`}
          >
            Adicionar saldo
          </Button>
        </Balance>
        

        <TagsOperations>
          <Tabs 
            variant="scrollable"
            scrollButtons="auto"
            value={tabValue} 
            onChange={handleChange}
          >
            <Tab 
              label="Todas" 
              {...a11yProps(0)}
            />
            <Tab 
              label="Pendente" 
              {...a11yProps(1)}
            />
            <Tab 
              label="Liberada" 
              {...a11yProps(2)} 
            />
            <Tab 
              label="Postada" 
              {...a11yProps(3)} 
            />
            <Tab 
              label="Entregue" 
              {...a11yProps(4)} 
            />
            <Tab 
              label="Cancelada" 
              {...a11yProps(5)} 
            />
            <Tab 
              label="Não entregue" 
              {...a11yProps(6)} 
            />
          </Tabs>

          <TabPanel value={tabValue} index={0}>
            <Button
              onClick={handleGenerate}
              disabled={!selected.length}
              className={classes.button}
            >
              Gerar
            </Button>
            <Button
              onClick={handlePrint}
              disabled={!selected.length}
              className={classes.button}
            >
              Imprimir
            </Button>
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <Button
              onClick={handleGenerate}
              disabled={!selected.length}
              className={classes.button}
            >
              Gerar
            </Button>
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <Button
              onClick={handlePrint}
              disabled={!selected.length}
              className={classes.button}
            >
              Imprimir
            </Button>
          </TabPanel>
          <TabPanel value={tabValue} index={3} /> 
          <TabPanel value={tabValue} index={4} />
          <TabPanel value={tabValue} index={5} />
          <TabPanel value={tabValue} index={6} />
        </TagsOperations>

        <EnhancedTable
          rows={filteredOrdersForTable}
          selected={selected}
          setSelected={setSelected}
          updateData={() => {
            handleGetOrders(possibleStatus[tabValue]);
            formRef.current?.submitForm();
          }}
          selectedBranch={selectedBranch}
        />
      </PageBody>

      {openAddBalanceModal && (
        <AddBalanceModal
          open={openAddBalanceModal}
          handleClose={handleCloseAddBalance}
          selectedBranch={selectedBranch}
        />
      )}
    </Container>
  );
}
